import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { IStep3Props } from './types';
import Select from 'react-select';
import { useSelect } from '../../../../../../utils/selector.utils';
import { authSelectors } from '../../../../../../app/auth/auth.selectors';
import { userSelectors } from '../../../../../../app/resource/user/user.selectors';
import { IUser } from '../../../../../../app/resource/user/user.types';
import { buildStyleForSelectInput } from '../../../../../../utils/form/style.util';

const Step3: FunctionComponent<IStep3Props> = ({ data, onNext, setAreUsersSelected }) => {
  const loggedUserId = useSelect(authSelectors.selectLoggedUser) || '';
  const [formData, setFormData] = useState({
    administrators: data.administrators ?? [loggedUserId],
    members: data.members ?? [],
  });

  // all tenant's users are eligible as members
  const users = useSelect(userSelectors.selectResourceList);
  const userOptions = users
    .filter((user) => ![...formData.members, ...formData.administrators].includes(user.id))
    .map((user) => ({
      value: user.id,
      label: `${user.firstName} ${user.lastName}`,
    }));

  const defaultMembers = useMemo(
    () =>
      users
        .filter((user) => formData.members.includes(user.id))
        .filter((user): user is IUser => user !== null)
        .map((user) => ({
          value: user.id,
          label: `${user.firstName} ${user.lastName}`,
        })),
    [users, formData.members],
  );

  const defaultAdmins = useMemo(
    () =>
      users
        .filter((user) => data.administrators.includes(user.id))
        .filter((user): user is IUser => user !== null)
        .map((user) => ({
          value: user.id,
          label: `${user.firstName} ${user.lastName}`,
        })),
    [users, data.administrators],
  );

  const handleChange = (name: string, value: any) => {
    const ids = value.map((element: any) => element.value);

    setAreUsersSelected(true);
    setFormData((prev) => ({
      ...prev,
      [name]: ids,
    }));
  };

  useEffect(() => {
    if (formData.administrators.length > 0 || formData.members.length > 0) {
      setAreUsersSelected(true);
    } else {
      setAreUsersSelected(false);
    }
  }, [formData, setAreUsersSelected]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onNext(formData);
  };

  return (
    <form id="meeting-templates-form" className="topic-form" onSubmit={handleSubmit} method="post">
      <div className="row">
        <div className="col-12" style={{ marginTop: '20px' }}>
          <div className="field-container">
            <label htmlFor="administrators">Administrators</label>
            <Select<{ label: string; value: string }, boolean>
              id="administrators"
              name="administrators"
              options={userOptions}
              defaultValue={defaultAdmins}
              isMulti={true}
              onChange={(e: any) => handleChange('administrators', e)}
              className="custom-select-new"
              styles={buildStyleForSelectInput(formData.administrators.length ?? 0)}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="field-container">
            <label htmlFor="members">Members</label>
            <Select<{ label: string; value: string }, boolean>
              id="members"
              name="members"
              options={userOptions}
              defaultValue={defaultMembers}
              isMulti={true}
              onChange={(e: any) => handleChange('members', e)}
              className="custom-select-new"
              styles={buildStyleForSelectInput(formData.members.length ?? 0)}
            />
          </div>
        </div>
      </div>
    </form>
  );
};
export default Step3;
